import * as React from 'react';
import { useState } from 'react';
import { NeonButton, NeonContainer, NeonQRBox, NeonTextField, NeonTypography } from './Neon';
import {theme as neonTheme} from './Neon';
import axios from "axios";
import { Box, Typography, Divider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

const QRCodeApp = () => {
    const [salespersonId, setSalespersonId] = useState("");
    const [qrCode, setQrCode] = useState("");
    const [qrLink, setQrLink] = useState(""); //Store the clickable link.
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleGenerateQR = async () => {
      if (!salespersonId.trim()) {
          setErrorMessage("Salesperson ID is required.");
          return;
      }
      setIsLoading(true);
      setErrorMessage("");
  
      try {
          console.log("Making POST request to:", `${process.env.REACT_APP_API_URL}`);
          console.log("Payload:", { salesperson_id: salespersonId });
  
          const response = await axios.post(
              `${process.env.REACT_APP_API_URL}`,
              {
                  salesperson_id: salespersonId,
              },
              {
                  headers: {
                      "Content-Type": "application/json", // Required header
                  },
              }
          );
  
          console.log("QR Code Response:", response.data);
          setQrCode(response.data.qr_code);
          setQrLink(`/marketing/${salespersonId}`); // Store the clickable link
      } catch (error) {
          console.error("Error generating QR code:", error);
          setErrorMessage(
              error.response?.data?.error || "Failed to generate QR code. Please try again."
          );
      } finally {
          setIsLoading(false);
      }
  };
        
    return (
      <ThemeProvider theme={neonTheme}>
        <NeonContainer>
          <Box>
            <NeonTypography variant="h3" gutterBottom 

                            sx={{
                            fontFamily: "'Press Start 2P'",
                            fontSize: "3rem",
                            textAlign: "center",
                            letterSpacing: "0.1em",
                            color: "#FF00FF",
                            textShadow: `
                            0 0 2px #FF00FF, 
                            0 0 4px #FF00FF, 
                            0 0 8px #FF00FF,
                            0 0 16px #FF00FF,
                            0 0 32px rgba(255, 0, 255, 0.75),
                            0 0 64px rgba(255, 0, 255, 0.5)
                            `,
                            filter: "drop-shadow(0 0 20px rgba(255, 0, 255, 0.9))",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            padding: "20px",
                            borderRadius: "15px",
                            display: "inline-block",
                            animation: "flicker 1.5s infinite alternate",
                            marginBottom: "5rem"
                          }}>
              QR Generator
            </NeonTypography>
            <Divider />
            <NeonTextField
              label="Enter Salesperson ID"
              variant="outlined"
              fullWidth
              value={salespersonId}
              onChange={(e) => setSalespersonId(e.target.value)}
              sx={{
                mb: "5rem",
                maxWidth: "400px", // Limit max width
                width: "90%", // Adjust width to be fluid
             }}
            />
            <Divider />
            <NeonButton onClick={handleGenerateQR} fullWidth sx={{maxWidth: "200px", width: "90%"}}>
            {isLoading ? (<Typography variant="body1" sx={{ mt: 2 }}>Generating your QR code...</Typography>) : ("Generate QR Code") }
            </NeonButton>
            
            {errorMessage && (
            <Typography variant="body2" color="primary" sx={{ mt: 6 }}>
              {errorMessage}
            </Typography>
          )}
          {/*--------------------------------------------------------------------------------------------------------------------------------------------------*/}
          {qrCode && (
            <NeonQRBox>
              <Typography variant="h6" gutterBottom>
                Your QR Code:
              </Typography>
              {/* Make QR Code clickable */}
              <a href={qrLink} target="_blank" rel="noopener noreferrer">
              <Box
                component="img"
                src={`data:image/png;base64,${qrCode}`}
                alt="QR Code"
                sx={{ width: "200px", height: "200px", margin: "0 auto" }}
              />
              </a>
              {/* Add Link to the Marketing Page */}
              <Typography variant="body1" sx={{ mt:2 }}>
                  <a
                  href={`/marketing/${salespersonId}`}
                  >
                      To view the marketing page for {salespersonId}, click here.
                  </a>
              </Typography>
            </NeonQRBox>
          )}

          </Box>
        </NeonContainer>
      </ThemeProvider>
    );
  };
  
export default QRCodeApp;
